import { schema } from "normalizr";

export const betriebeSchema = new schema.Entity("betriebe");
